import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './Logo';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Services', path: '/services' },
    { name: 'Insights', path: '/#insights' },
    { name: 'About', path: '/#about' }
  ];

  const headerClass = isScrolled || !isHome || mobileMenuOpen
    ? 'bg-white/95 backdrop-blur-md shadow-sm py-4' 
    : 'bg-transparent py-6';

  const linkClass = isScrolled || !isHome || mobileMenuOpen
    ? 'text-slate-600 hover:text-amber-600' 
    : 'text-slate-200 hover:text-white';

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${headerClass}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between">
        <Link to="/" onClick={() => setMobileMenuOpen(false)}>
          <Logo light={isHome && !isScrolled && !mobileMenuOpen} />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
             link.path.startsWith('/#') ? (
              <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors ${linkClass}`}>
                {link.name}
              </Link>
             ) : (
              <Link key={link.name} to={link.path} onClick={() => window.scrollTo(0,0)} className={`text-sm font-medium transition-colors ${linkClass}`}>
                {link.name}
              </Link>
             )
          ))}
          <Link to="/contact" onClick={() => window.scrollTo(0,0)}>
            <button className={`px-5 py-2 text-sm font-semibold transition-all ${
              isScrolled || !isHome ? 'bg-slate-900 text-white hover:bg-slate-800' : 'bg-white text-slate-900 hover:bg-slate-100'
            }`}>
              Contact Us
            </button>
          </Link>
        </nav>

        <button className="md:hidden p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <SafeIcon icon={mobileMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} 
            className={`w-6 h-6 ${isScrolled || !isHome || mobileMenuOpen ? 'text-slate-900' : 'text-white'}`} />
        </button>
      </div>

      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="absolute top-full left-0 w-full bg-white shadow-xl py-6 px-6 md:hidden flex flex-col gap-4"
          >
            {navLinks.map((link) => (
              <Link key={link.name} to={link.path} 
                 className="text-lg font-medium text-slate-800 hover:text-amber-600"
                 onClick={() => setMobileMenuOpen(false)}>
                {link.name}
              </Link>
            ))}
            <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>
              <button className="mt-4 w-full bg-slate-900 text-white py-3 font-semibold">
                Contact Us
              </button>
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}